// src/db/models/assessmentModel.js
import { api } from '../../api/client';
import { VALIDATION_RULES } from '../schema';

export const AssessmentModel = {

  async create(assessmentData) {
    try {
      if (!assessmentData.id || !assessmentData.name || !assessmentData.fileName) {
        throw new Error('Missing required fields: id, name, and fileName are required');
      }

      if (!VALIDATION_RULES.assessments.id.pattern.test(assessmentData.id)) {
        throw new Error(VALIDATION_RULES.assessments.id.message);
      }

      if (!VALIDATION_RULES.assessments.fileName.pattern.test(assessmentData.fileName)) {
        throw new Error(VALIDATION_RULES.assessments.fileName.message);
      }

      const payload = {
        id: assessmentData.id,
        name: assessmentData.name,
        fileName: assessmentData.fileName,
        assessmentKind: assessmentData.assessmentKind || 'gradeLevel',
        assessmentPool: assessmentData.assessmentPool || 'NA'
      };

      if (payload.assessmentKind === 'regular') {
        if (!payload.assessmentPool || payload.assessmentPool === 'NA') {
          payload.assessmentPool = 'NonPooled';
        }
      } 

      else if (payload.assessmentKind === 'gradeLevel') {
        payload.assessmentPool = 'NA';
      }

      const result = await api.createAssessment(payload);
      return result;

    } catch (error) {
      console.error('[AssessmentModel] Error creating assessment:', error);
      throw error;
    }
  },

  async findAll() {
    try {
      const assessments = await api.getAllAssessments();
      return assessments;
    } catch (error) {
      console.error('[AssessmentModel] Error retrieving assessments:', error);
      throw error;
    }
  },

  async findById(id) {
    try {
      if (!id) {
        throw new Error('Assessment ID is required');
      }

      const assessment = await api.getAssessment(id);
      return assessment;
    } catch (error) {
      console.error('[AssessmentModel] Error finding assessment:', error);
      throw error;
    }
  },

  async update(id, assessmentData) {
    try {
      if (!id) {
        throw new Error('Assessment ID is required');
      }
      if (!assessmentData.name || !assessmentData.fileName) {
        throw new Error('Name and fileName are required for update');
      }

      const payload = { ...assessmentData };

      if (!payload.assessmentKind) {
        payload.assessmentKind = 'gradeLevel';
      }

      if (payload.assessmentKind === 'regular') {
        if (!payload.assessmentPool || payload.assessmentPool === 'NA') {
          payload.assessmentPool = 'NonPooled';
        }
      } 
      else if (payload.assessmentKind === 'gradeLevel') {
        payload.assessmentPool = 'NA';
      }

      const result = await api.updateAssessment(id, payload);
      return result;
    } catch (error) {
      console.error('[AssessmentModel] Error updating assessment:', error);
      throw error;
    }
  },

  async delete(id) {
    try {
      if (!id) {
        throw new Error('Assessment ID is required');
      }

      const result = await api.deleteAssessment(id);
      return result.success;
    } catch (error) {
      console.error('[AssessmentModel] Error deleting assessment:', error);
      throw error;
    }
  }
};
